import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
import UserNotification from "util/UserNotification";
import useUserDateTime from "hooks/useUserDateTime";
import { getDataLakeUriParams } from "data-lake/logic/Utils";
import { handleFailures } from "data-lake/data-lake-overview/actions/Utils";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import DataLakeDeleteActionForm from "data-lake/components/DataLakeActionModals/DataLakeDeleteActionForm";
const DeleteArchiveModal = ({ archiveStreamId, onToggleModal }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const { selectedDataLake } = useSelectedDataLake();
  const { userTimezone } = useUserDateTime();
  const queryClient = useQueryClient();
  const onDeleteSubmit = useCallback(
    (values) => {
      const uriParams = getDataLakeUriParams(values, userTimezone);
      fetch("POST", qualifyUrl(`${DATA_LAKE_API_ROUTES.DataLakeAPIController.bulk_delete().url}?${uriParams}`), {
        stream_ids: [archiveStreamId]
      }).then((response) => {
        const failures = (response == null ? void 0 : response.failures) || [];
        handleFailures(failures, "deleted");
      }).catch((error) => {
        UserNotification.error(t("delete_archive_modal.error", { error: `${error}` }));
      }).finally(() => {
        queryClient.invalidateQueries({
          queryKey: ["data-lake"]
        });
        onToggleModal();
      });
    },
    [userTimezone, archiveStreamId, queryClient, onToggleModal, t]
  );
  return /* @__PURE__ */ React.createElement(
    DataLakeDeleteActionForm,
    {
      show: true,
      onHide: onToggleModal,
      dataLakeId: selectedDataLake.id,
      streamIds: [archiveStreamId],
      onSubmit: onDeleteSubmit
    },
    /* @__PURE__ */ React.createElement("p", null, t("delete_archive_modal.confirm"))
  );
};
export default DeleteArchiveModal;
